'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iconBase = require('../icon-base');

var _iconBase2 = _interopRequireDefault(_iconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FaSearch = function (_React$Component) {
  _inherits(FaSearch, _React$Component);

  function FaSearch() {
    _classCallCheck(this, FaSearch);

    return _possibleConstructorReturn(this, (FaSearch.__proto__ || Object.getPrototypeOf(FaSearch)).apply(this, arguments));
  }

  _createClass(FaSearch, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _iconBase2.default,
        this.props,
        _react2.default.createElement(
          'g',
          null,
          _react2.default.createElement('path', { d: 'M1152 832q0-185-131.5-316.5T704 384 387.5 515.5 256 832t131.5 316.5T704 1280t316.5-131.5T1152 832zm512 832q0 52-38 90t-90 38q-54 0-90-38l-343-342q-179 124-399 124-143 0-273.5-55.5t-225-150-150-225T0 832t55.5-273.5 150-225 225-150T704 128t273.5 55.5 225 150 150 225T1408 832q0 220-124 399l343 343q37 37 37 90z' })
        )
      );
    }
  }]);

  return FaSearch;
}(_react2.default.Component);

FaSearch.defaultProps = {
  viewBox: '0 0 1672.2646 1896.0833',
  height: '1em',
  width: '0.8820em'
};

exports.default = FaSearch;


//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-icons/lib/fa/search.js
// module id = 206
// module chunks = 0 1 2 3 4 5 6